export enum DprForecastData {
  CustomData = 1,
  Subactivities,
}
